mutation refreshToken($refreshToken: String!) {
    refreshToken(refreshToken: $refreshToken)
}
